module.exports = __webpack_public_path__ + "static/media/icoRank1.59a52fd5.png";